// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QC Job Viewer Styles */

.job-viewer {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: grid;
  gap: 20px;
}

.job-viewer.compact {
  padding: 12px;
}

.job-info-compact {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  font-size: 13px;
}

/* Viewer Header */
.viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.job-title {
  display: grid;
  gap: 4px;
}

.job-title h3 {
  margin: 0;
  font-size: 18px;
  color: #1f2937;
  word-break: break-word;
}

.job-id {
  font-family: "Courier New", monospace;
  font-size: 12px;
  color: #6b7280;
  padding: 4px 8px;
  background: #f3f4f6;
  border-radius: 4px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Viewer Actions */
.viewer-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* Status Overview */
.status-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 6px;
}

.status-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-item label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
}

.status-item span {
  font-size: 14px;
  color: #1f2937;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  width: fit-content;
}

.status-pending,
.status-processing {
  background: #fef3c7;
  color: #92400e;
}

.status-completed {
  background: #d1fae5;
  color: #065f46;
}

.status-failed {
  background: #fee2e2;
  color: #991b1b;
}

.qc-passed {
  background: #d1fae5;
  color: #065f46;
}

.qc-failed {
  background: #fee2e2;
  color: #991b1b;
}

/* Summary Section */
.summary-section {
  padding: 16px;
  background: #f0fdf4;
  border-left: 4px solid #10b981;
  border-radius: 4px;
}

.summary-section h4 {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 600;
  color: #065f46;
}

.summary-section p {
  margin: 0;
  font-size: 14px;
  color: #1f2937;
  line-height: 1.5;
}

/* Findings Section */
.findings-section {
  display: grid;
  gap: 12px;
}

.findings-section h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.findings-list {
  display: grid;
  gap: 12px;
}

.finding-card {
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  border-left: 4px solid #d1d5db;
  background: #fafafa;
}

.finding-header {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.severity {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.severity-critical {
  background: #fee2e2;
  color: #991b1b;
}

.severity-major {
  background: #fed7aa;
  color: #92400e;
}

.severity-minor {
  background: #fef3c7;
  color: #78350f;
}

.timestamp {
  font-size: 12px;
  color: #6b7280;
  padding: 2px 6px;
  background: #f3f4f6;
  border-radius: 3px;
}

.policy-ref {
  font-size: 12px;
  color: #6b7280;
  padding: 2px 6px;
  background: #e0e7ff;
  border-radius: 3px;
}

.finding-issue {
  margin: 0;
  font-size: 14px;
  color: #1f2937;
  line-height: 1.5;
}

.mention {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #667eea;
  font-weight: 500;
}

/* Comments Section */
.comments-section {
  display: grid;
  gap: 12px;
}

.comments-section h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.comments-list {
  display: grid;
  gap: 12px;
}

.comment-card {
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
}

.comment-meta {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
  font-size: 12px;
}

.comment-meta strong {
  color: #1f2937;
  font-weight: 600;
}

.comment-meta .mention {
  margin: 0;
}

.comment-meta .severity {
  margin: 0;
}

.comment-card p {
  margin: 8px 0 0 0;
  font-size: 14px;
  color: #1f2937;
  line-height: 1.5;
}

.comment-card .policy-ref {
  display: inline-block;
  margin-top: 4px;
}

.comment-card .timestamp {
  display: block;
  margin-top: 8px;
  color: #9ca3af;
}

/* Raw Analysis & Metadata */
.raw-analysis-section,
.metadata-section,
.details-section {
  margin-top: 8px;
}

.raw-analysis-section details,
.metadata-section details,
.details-section details {
  cursor: pointer;
}

.raw-analysis-section summary,
.metadata-section summary,
.details-section summary {
  font-size: 13px;
  font-weight: 500;
  color: #667eea;
  padding: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.raw-analysis-section summary:hover,
.metadata-section summary:hover,
.details-section summary:hover {
  background: #f3f4f6;
  border-radius: 4px;
}

pre {
  margin: 12px 0 0 0;
  padding: 12px;
  background: #1f2937;
  color: #e5e7eb;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 12px;
  line-height: 1.4;
  font-family: "Courier New", monospace;
}

/* Responsive */
@media (max-width: 768px) {
  .job-viewer {
    padding: 16px;
  }

  .viewer-header {
    flex-direction: column;
    align-items: stretch;
  }

  .viewer-actions {
    justify-content: flex-start;
  }

  .status-overview {
    grid-template-columns: 1fr 1fr;
  }

  pre {
    font-size: 11px;
    padding: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/QC/QCJobViewer.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* QC Job Viewer Styles */\n\n.job-viewer {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  display: grid;\n  gap: 20px;\n}\n\n.job-viewer.compact {\n  padding: 12px;\n}\n\n.job-info-compact {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n  font-size: 13px;\n}\n\n/* Viewer Header */\n.viewer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.job-title {\n  display: grid;\n  gap: 4px;\n}\n\n.job-title h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #1f2937;\n  word-break: break-word;\n}\n\n.job-id {\n  font-family: \"Courier New\", monospace;\n  font-size: 12px;\n  color: #6b7280;\n  padding: 4px 8px;\n  background: #f3f4f6;\n  border-radius: 4px;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Viewer Actions */\n.viewer-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n/* Status Overview */\n.status-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 6px;\n}\n\n.status-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.status-item label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.status-item span {\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  width: fit-content;\n}\n\n.status-pending,\n.status-processing {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-completed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.qc-passed {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.qc-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Summary Section */\n.summary-section {\n  padding: 16px;\n  background: #f0fdf4;\n  border-left: 4px solid #10b981;\n  border-radius: 4px;\n}\n\n.summary-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #065f46;\n}\n\n.summary-section p {\n  margin: 0;\n  font-size: 14px;\n  color: #1f2937;\n  line-height: 1.5;\n}\n\n/* Findings Section */\n.findings-section {\n  display: grid;\n  gap: 12px;\n}\n\n.findings-section h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.findings-list {\n  display: grid;\n  gap: 12px;\n}\n\n.finding-card {\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  border-left: 4px solid #d1d5db;\n  background: #fafafa;\n}\n\n.finding-header {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n\n.severity {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.severity-critical {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.severity-major {\n  background: #fed7aa;\n  color: #92400e;\n}\n\n.severity-minor {\n  background: #fef3c7;\n  color: #78350f;\n}\n\n.timestamp {\n  font-size: 12px;\n  color: #6b7280;\n  padding: 2px 6px;\n  background: #f3f4f6;\n  border-radius: 3px;\n}\n\n.policy-ref {\n  font-size: 12px;\n  color: #6b7280;\n  padding: 2px 6px;\n  background: #e0e7ff;\n  border-radius: 3px;\n}\n\n.finding-issue {\n  margin: 0;\n  font-size: 14px;\n  color: #1f2937;\n  line-height: 1.5;\n}\n\n.mention {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: #667eea;\n  font-weight: 500;\n}\n\n/* Comments Section */\n.comments-section {\n  display: grid;\n  gap: 12px;\n}\n\n.comments-section h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.comments-list {\n  display: grid;\n  gap: 12px;\n}\n\n.comment-card {\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n}\n\n.comment-meta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n\n.comment-meta strong {\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.comment-meta .mention {\n  margin: 0;\n}\n\n.comment-meta .severity {\n  margin: 0;\n}\n\n.comment-card p {\n  margin: 8px 0 0 0;\n  font-size: 14px;\n  color: #1f2937;\n  line-height: 1.5;\n}\n\n.comment-card .policy-ref {\n  display: inline-block;\n  margin-top: 4px;\n}\n\n.comment-card .timestamp {\n  display: block;\n  margin-top: 8px;\n  color: #9ca3af;\n}\n\n/* Raw Analysis & Metadata */\n.raw-analysis-section,\n.metadata-section,\n.details-section {\n  margin-top: 8px;\n}\n\n.raw-analysis-section details,\n.metadata-section details,\n.details-section details {\n  cursor: pointer;\n}\n\n.raw-analysis-section summary,\n.metadata-section summary,\n.details-section summary {\n  font-size: 13px;\n  font-weight: 500;\n  color: #667eea;\n  padding: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.raw-analysis-section summary:hover,\n.metadata-section summary:hover,\n.details-section summary:hover {\n  background: #f3f4f6;\n  border-radius: 4px;\n}\n\npre {\n  margin: 12px 0 0 0;\n  padding: 12px;\n  background: #1f2937;\n  color: #e5e7eb;\n  border-radius: 6px;\n  overflow-x: auto;\n  font-size: 12px;\n  line-height: 1.4;\n  font-family: \"Courier New\", monospace;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .job-viewer {\n    padding: 16px;\n  }\n\n  .viewer-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .viewer-actions {\n    justify-content: flex-start;\n  }\n\n  .status-overview {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  pre {\n    font-size: 11px;\n    padding: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
